import { RuleId, RuleLevel } from '../../../types-v2';
const NOT_CLASSIFIED_LANGUAGE = 'not classified';
export const siteLanguageRule = {
  checker: _ref => {
    let {
      detectedLanguage,
      settingsLanguage,
      isMultilingualEnabled
    } = _ref;
    return {
      status: isMultilingualEnabled || !detectedLanguage || detectedLanguage === NOT_CLASSIFIED_LANGUAGE || settingsLanguage === detectedLanguage ? 'passed' : 'failed'
    };
  },
  level: RuleLevel.Site,
  ruleId: RuleId.SITE_LANGUAGE
};
//# sourceMappingURL=site-language.js.map